// Avisos entre pantallas que no comparten estado. El Mapa del tesoro lo dispara después de poner o
// quitar una marca a mano, y el contador ⭐ del menú (Layout) lo escucha para releerse.
export const EVENTO_MAPA = "huayruro:mapa-cambio";

export function avisarCambioDelMapa(): void {
  window.dispatchEvent(new Event(EVENTO_MAPA));
}
